// Product group configuration - products that share the same interstitial flows
export const PRODUCT_GROUPS = {
  'rugiet-ed': ['rugiet-men-ed', 'rugiet-ready'],
  recharge: ['recharge'],
} as const;

// Type definitions
export type ProductGroup = keyof typeof PRODUCT_GROUPS;
export type ProductSlug = (typeof PRODUCT_GROUPS)[ProductGroup][number];

/**
 * Determines which product group a slug belongs to
 * @param slug - The product slug to check
 * @returns The product group name or null if not found
 */
export const getProductGroup = (slug: string | null | undefined): ProductGroup | null => {
  if (!slug) return null;

  for (const [group, slugs] of Object.entries(PRODUCT_GROUPS)) {
    if ((slugs as readonly string[]).includes(slug)) return group as ProductGroup;
  }
  return null;
};

/**
 * Checks if a slug belongs to a specific product group
 * @param slug - The product slug to check
 * @param group - The product group to check against
 * @returns true if the slug belongs to the group
 */
export const isProductInGroup = (slug: string | null | undefined, group: ProductGroup): boolean => {
  return getProductGroup(slug) === group;
};
